import React from "react";
import ReactDOM from "react-dom/client";
import App from "./pages";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import ThemeProvider from "./provider/ThemeProvider";
import { BrowserRouter } from "react-router-dom";
import createStore from "./store";


const store = createStore()

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const isDevelopment =
  process.env.NODE_ENV === "development";

root.render(
  <>
    {isDevelopment && <React.StrictMode>
      <Provider store={store}>
          <ThemeProvider>
            <BrowserRouter>
              <App />
            </ BrowserRouter>
          </ThemeProvider>
      </Provider>
    </React.StrictMode>}
    {!isDevelopment &&
      <Provider store={store}>
          <ThemeProvider>
            <BrowserRouter>
              <App />
            </ BrowserRouter>
          </ThemeProvider>
      </Provider>
    }
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
